"use client";

import type { FC, Ref } from "react";
import {
  ExpenseCard,
  usePubSub,
  type UserPromptRecord,
  type ValueType,
} from "@huub-web/ui";

import { useTemplates } from "../../hooks/useTemplates";

export interface ExpenseCardTemplateProps {
  title: string;
  subtitle?: string;
  titleColor?: "default" | "accent" | "success";
  value: ValueType;
  helpPrompt?: UserPromptRecord;
}

export const ExpenseCardTemplate: FC<
  ExpenseCardTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, subtitle, value, helpPrompt, titleColor = "default", ref }) => {
  const { lockPrompts } = useTemplates();
  const pubSub = usePubSub();

  const handleHelpPrompt = (prompt?: UserPromptRecord) => {
    if (prompt) {
      pubSub.publish("sendPrompt", { value: prompt });
    }
  };

  return (
    <ExpenseCard
      ref={ref}
      title={title}
      body={subtitle}
      value={value}
      helpPrompt={helpPrompt}
      disabled={lockPrompts}
      titleColor={titleColor}
      onHelpPrompt={() => handleHelpPrompt(helpPrompt)}
    />
  );
};
